/** Exact user-facing product name (capital F only; all other letters lowercase). */
export const BRAND_NAME = "Floorpilot" as const

/** Public marketing site; used e.g. as the Clerk card logo link target. */
export const MARKETING_URL = "https://www.floorpilotselections.com" as const
